import React from 'react'
import { PreloaderLine } from '@rst/ui-ts'
import { calcBlockHeight, formatText, usePreloaderFont } from '@rst/libs-ts'
import styled from 'styled-components'

export const LeadFormHalfMobPreloader = (data: any) => {
	const descr = formatText(data.subtitle)
	const heightTitle = calcBlockHeight(
		data.title,
		usePreloaderFont(data),
		27,
		110,
		Math.min(window.innerWidth, 755)
	)

	return (
		<>
			<ImageWrapp align={data.align}>
				<Image bgType={data.bg_type}>
					<PreloaderLine />
				</Image>
			</ImageWrapp>
			<LeadWrapp align={data.align}>
				<Lead bgType={data.bg_type}>
					<Header heightTitle={heightTitle}>
						<PreloaderLine />
						<Desc>
							{descr.map((x: { tag: string; text: any }, i: any) =>
								x.tag === 'ulArr' ? (
									<UlWrapp>
										{x.text.map((z: any) => (
											<PreloadUl {...data} {...z} />
										))}
									</UlWrapp>
								) : (
									<AnotherTag>
										<PreloadSubTitle {...data} {...x} key={i} />
									</AnotherTag>
								)
							)}
						</Desc>
					</Header>
					<Sep>
						<PreloaderLine />
					</Sep>
					<Form>
						<TopForm>
							<PreloaderLine />
							<PreloaderLine />
						</TopForm>
					</Form>
					<ButtonBlock>
						<PreloaderLine />
						<Info>
							<PreloaderLine />
							<PreloaderLine />
							<PreloaderLine />
						</Info>
					</ButtonBlock>
				</Lead>
			</LeadWrapp>
		</>
	)
}

const PreloadSubTitle = (data: any) => {
	const heightDescription = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth - 35, 755),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightDescription} />
}

const PreloadUl = (data: any) => {
	const heightUl = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth, 755),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightUl} />
}

const Desc = styled.div`
	& > div {
		width: 100%;

		&:last-child {
			margin-bottom: 0;
		}
	}
`

const UlWrapp = styled.div`
	display: flex;
	flex-direction: column;
`

const AnotherTag = styled.div`
	margin-bottom: 0;
`

const ImageWrapp = styled.div<{ align: string }>`
	flex-basis: 40%;
	justify-content: ${p => (p.align === 'right' ? 'right' : 'left')};
`

const Image = styled.div<{ bgType: string }>`
	display: flex;
	aspect-ratio: 0.732952 / 1;

	aspect-ratio: ${p =>
		p.bgType === 'square'
			? '0.732952 / 1'
			: p.bgType === 'parallelogram'
			? '1.042161 / 1'
			: p.bgType === 'phone'
			? '0.9259462 / 1'
			: '1/1'};

	& > div {
		width: 100%;
		border-radius: 0px;
	}
`

const LeadWrapp = styled.div<{ align: string }>`
	flex-basis: 60%;
	display: flex;
	justify-content: ${p => (p.align === 'right' ? 'left' : 'right')}; ;
`

const Lead = styled.div<{ bgType: string }>`
	padding-top: 36px;
	padding-bottom: 32px;
	flex-direction: column;
	justify-content: center;
	padding-left: 16px;
	padding-right: 16px;
	width: 100%;
	max-width: 700px;

	padding: ${p =>
		p.bgType === 'square'
			? '36px 16px 32px 16px'
			: p.bgType === 'parallelogram'
			? '25px 16px 25px 16px'
			: p.bgType === 'phone'
			? '32px 60px 32px 32px'
			: '32px 60px 32px 32px'};
`

const Sep = styled.div`
	& > div {
		width: 100%;
		height: 1px;
		margin-top: 16px;
	}
`

const Header = styled.div<{ heightSubTitle?: number; heightTitle: number }>`
	gap: 16px;
	display: flex;
	flex-direction: column;

	& > div {
		&:nth-child(1) {
			height: ${p => `${p.heightTitle}px`};
			width: 100%;
		}
	}
`

const SubTitle = styled.div`
	& > div {
		border-radius: 0;
		&:only-child {
			border-radius: 16px !important;
		}
		&:first-child {
			border-radius: 16px 16px 0 0;
		}
		&:last-child {
			border-radius: 0 0 16px 16px;
		}
	}
`

const Form = styled.div`
	margin-top: 16px;
`

const TopForm = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	& > div {
		height: 56px;

		&:nth-child(1) {
			width: 100%;
		}

		&:nth-child(2) {
			width: 100%;
		}
	}
`

const Info = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 57px;
	& > div {
		height: 10px;

		&:nth-child(2) {
			width: 60%;
		}

		&:nth-child(3) {
			width: 75%;
		}
	}
`

const ButtonBlock = styled.div`
	display: flex;
	gap: 10px;
	flex-direction: column;
	margin-top: 8px;
	& > div {
		display: flex;
		width: 100%;

		&:nth-child(1) {
			height: 48px;
		}

		&:first-child {
			width: 100%;
		}
	}
`
